import { theme } from "../../constants/StyledComponents";
import { FontWeightEnum } from "../../types/AppTypes";
import { BodyTyp } from "../Typography/Typography";
import { StyledBadgeIndex } from "./BadgeIndex.styled";

type BadgeIndexProps = {
  content: string;
};

export const BadgeIndex = ({ content }: BadgeIndexProps) => {
  return (
    <StyledBadgeIndex>
      <BodyTyp
        variant="2"
        fontWeight={FontWeightEnum.SEMIBOLD}
        color={theme.colors.purple}
      >
        {content}
      </BodyTyp>
    </StyledBadgeIndex>
  );
};
